import { Button, Col, Form, Input, Modal, Row, Select } from 'antd'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import DaumPostcodeEmbed from 'react-daum-postcode'
import { useRecoilState } from 'recoil'
import orderApi from '../../api/order.api'
import { userState } from '../../store/user'
import statusUtil from '../../utils/status'

const OrderDetailComponent = ({
  orderDetail,
  handleOrderDetailModalCancel,
  getUserOrderList,
}) => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)

  const [returnAccount, setReturnAccount] = useState(false)
  const [refundHolder, setRefundHolder] = useState(orderDetail?.name)
  const [editStatus, setEditStatus] = useState(false)
  const [deliveryInfo, setDeliveryInfo] = useState({})
  const [isPostalCodeModalOpen, setIsPostalCodeModalOpen] = useState(false)

  const bankList = [
    {
      id: 1,
      name: '국민',
    },
    {
      id: 2,
      name: '신한',
    },
    {
      id: 3,
      name: '농협',
    },
  ]

  const handleEditClick = () => {
    setDeliveryInfo({
      name: orderDetail.name,
      phone: orderDetail.phone,
      postalCode: orderDetail.postalCode,
      address: orderDetail.address,
      addressDetail: orderDetail.addressDetail,
      addressRequest: orderDetail.addressRequest,
    })
    setEditStatus(true)
  }

  const handleEditCancelClick = () => {
    if (
      orderDetail.name !== deliveryInfo.name ||
      orderDetail.phone !==
        (deliveryInfo.phone.includes('-')
          ? deliveryInfo.phone.replaceAll('-', '')
          : deliveryInfo.phone) ||
      orderDetail.address !== deliveryInfo.address ||
      orderDetail.addressDetail !== deliveryInfo.addressDetail ||
      orderDetail.addressRequest !== deliveryInfo.addressRequest
    ) {
      if (
        window.confirm(
          '지금까지 수정했던 내용들이 저장되지 않습니다. 그래도 취소하시겠습니까?',
        )
      ) {
        setEditStatus(false)
        setDeliveryInfo({})
      }
    } else {
      setEditStatus(false)
      setDeliveryInfo({})
    }
  }

  const handleEditCompleteClick = async () => {
    if (window.confirm('작성하신 내용으로 변경하시겠습니까?')) {
      setIsLoading(true)
      try {
        const param = {
          id: orderDetail.orderId,
          name: deliveryInfo.name,
          phone: deliveryInfo.phone.includes('-')
            ? deliveryInfo.phone.replaceAll('-', '')
            : deliveryInfo.phone,
          postalCode: deliveryInfo.postalCode,
          address: deliveryInfo.address,
          addressDetail: deliveryInfo.addressDetail,
          addressRequest: deliveryInfo.addressRequest,
        }
        const res = await orderApi.manualOrderDeliveryInfoEdit(param, user.id)
        if (res.data.code === 200) {
          alert('해당 수정 사항이 정상적으로 반영되었습니다.')
          handleOrderDetailModalCancel()
          getUserOrderList()
        } else {
          throw res.data.msg
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setDeliveryInfo({ ...deliveryInfo, [name]: value })
  }

  /**
   * Post Code 입력하기 (다음 주소 api)
   */
  const handlePostCode = (data) => {
    let fullAddress = data.address
    let extraAddress = ''

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname
      }
      if (data.buildingName !== '') {
        extraAddress +=
          extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : ''
    }

    if (fullAddress?.length > 0) {
      setDeliveryInfo({
        ...deliveryInfo,
        postalCode: data.zonecode,
        address: fullAddress,
      })
    }
    setIsPostalCodeModalOpen(false) // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  }

  const disabledEditCompleteBtn = () => {
    if (
      orderDetail.name === deliveryInfo.name &&
      orderDetail.phone ===
        (deliveryInfo.phone.includes('-')
          ? deliveryInfo.phone.replaceAll('-', '')
          : deliveryInfo.phone) &&
      orderDetail.address === deliveryInfo.address &&
      orderDetail.addressDetail === deliveryInfo.addressDetail &&
      orderDetail.addressRequest === deliveryInfo.addressRequest
    ) {
      return true
    } else if (
      !deliveryInfo.name ||
      !deliveryInfo.phone ||
      !deliveryInfo.address
    ) {
      return true
    } else if (isLoading) {
      return true
    } else {
      return false
    }
  }

  /**
   * 송장번호에 따른 배송안내 popup
   * @param detail
   */
  const deliveryPopup = (e, type, detail) => {
    e.preventDefault()
    e.stopPropagation()
    let popUrl = ''
    if (type === 'return') {
      popUrl = `https://www.goodsflow.io/tracking/tXYtiyVnAX/${detail.returnGoodsFlowServiceId}`
    } else {
      popUrl = `https://www.goodsflow.io/tracking/tXYtiyVnAX/${detail.goodsFlowServiceId}`
    }
    let popOption =
      'top=10, left=10, width=500, height=700, scrollbars=yes, resizable=no'
    window.open(popUrl, '배송조회', popOption)
  }

  /**
   * 유입경로
   * @param detail
   * @returns {string}
   */
  const funnels = (detail) => {
    let path = ''
    if (detail?.query) {
      if (detail?.isCooperate) {
        path = '공동구매'
      } else {
        if (detail?.isManual) {
          path = '전화주문-'
        }
        if (
          detail?.influencerRole === 'super_admin' ||
          detail?.influencerRole === 'level_1'
        ) {
          path += '인플루언서'
        } else {
          path += '셀러'
        }
      }
    } else if (detail?.isManual) {
      path = '전화주문'
    } else {
      path = '검색'
    }
    return path
  }

  return (
    <>
      <>
        {returnAccount && (
          <Modal
            title="환불 계좌 받기"
            open={returnAccount}
            onCancel={() => setReturnAccount(false)}
            cancelText={<span>닫기</span>}
            okText={<span>주문 취소</span>}
            width={'50%'}
          >
            <Form.Item
              label="은행"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Select
                placeholder="선택"
                style={{ width: 250, textAlign: 'left' }}
              >
                {bankList.map((item, idx) => (
                  <Select.Option key={`환불계좌_${idx}`} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="계좌 번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                className="order-modal-address-request-wrap"
                name="cancelReasonDetail"
                rows={5}
              />
            </Form.Item>
            <Form.Item
              label="예금주"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                className="order-modal-address-request-wrap"
                name="cancelReasonDetail"
                value={refundHolder}
                onChange={(e) => {
                  setRefundHolder(e.target.value)
                }}
                rows={5}
              />
            </Form.Item>
          </Modal>
        )}
      </>
      <div
        className="order-detail-modal-subtitle"
        style={{
          marginTop: 0,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        주문 상세정보
        {(orderDetail.payMethod === 'vbank' ||
          orderDetail.payMethod === 'deposit') && (
          <Button
            onClick={() => setReturnAccount(true)}
            style={{
              display: 'none',
            }}
          >
            환불 계좌
          </Button>
        )}
      </div>
      <Form.Item
        className="order-detail-border-box"
        label="상품주문번호"
        labelAlign="left"
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
      >
        <div className="order-id-wrap">{orderDetail.orderId}</div>
      </Form.Item>
      <Form.Item
        className="order-detail-form-border-box"
        label="상품명"
        labelAlign="left"
        colon={false}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
      >
        {`[${orderDetail.brandName}] ${orderDetail.productName}`}
      </Form.Item>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="상품주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {Object.prototype.hasOwnProperty.call(orderDetail, 'isDeposit') &&
            orderDetail.isDeposit &&
            orderDetail.orderDetailStatus === 'ready'
              ? '무통장 입금대기'
              : statusUtil.orderStatusChange(orderDetail.orderDetailStatus)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="클레임"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          ></Form.Item>
        </Col>
      </Row>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="구매자명"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {orderDetail.createdByName}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="유입경로"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {funnels(orderDetail) +
              (orderDetail?.influencerName
                ? `-${orderDetail?.influencerName}`
                : '')}
          </Form.Item>
        </Col>
      </Row>
      <Row align="stretch" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="옵션"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {orderDetail.optionTitle ? orderDetail.optionTitle : ''}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="주문수량"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ height: '100%' }}
          >
            {orderDetail.quantity}
          </Form.Item>
        </Col>
      </Row>
      <Row align="stretch" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="쿠폰 번호"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0, height: '100%' }}
          >
            {orderDetail.couponId ? orderDetail.couponId : ''}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="쿠폰명"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {orderDetail.couponTitle ? orderDetail.couponTitle : ''}
          </Form.Item>
        </Col>
      </Row>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="사용 포인트"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {orderDetail.usePoint ? orderDetail.usePoint.toLocaleString() : ''}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="상품별 할인액"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {orderDetail.couponDiscountPrice && orderDetail.usePoint
              ? (
                  orderDetail.couponDiscountPrice + orderDetail.usePoint
                ).toLocaleString() + '원'
              : orderDetail.usePoint
                ? orderDetail.usePoint.toLocaleString() + '원'
                : orderDetail.couponDiscountPrice
                  ? orderDetail.couponDiscountPrice.toLocaleString() + '원'
                  : ''}
          </Form.Item>
        </Col>
      </Row>
      <Row align="stretch" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="결제 방식"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0, height: '100%' }}
          >
            {orderDetail.payMethod
              ? statusUtil.matchingPayMethod[orderDetail.payMethod]
              : ''}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="가상 계좌 번호"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {orderDetail.payMethod && orderDetail.payMethod === 'vbank'
              ? orderDetail.vbankName + ' ' + orderDetail.vbankNum
              : ''}
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        className="order-detail-form-border-box"
        label="총 상품금액"
        labelAlign="left"
        colon={false}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        style={{ borderBottom: 'solid 1px #ced4da' }}
      >
        {orderDetail.totalPrice.toLocaleString() + '원'}
      </Form.Item>
      {Object.prototype.hasOwnProperty.call(orderDetail, 'isDeposit') &&
        orderDetail.isDeposit && (
          <>
            <div className="order-detail-modal-subtitle">무통장 주문 정보</div>
            <Form.Item
              className="order-detail-form-border-box"
              label="입금자명"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {orderDetail.depositName}
            </Form.Item>
            <Row align="stretch" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box order-detail-label-overflow"
                  label="현금영수증 신청 여부"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.cashReceiptType !== null ? 'Y' : 'N'}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box order-detail-label-overflow"
                  label="현금영수증 발급 여부"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.cashReceiptIssue !== null ? 'Y' : 'N'}
                </Form.Item>
              </Col>
            </Row>
            <Row align="stretch" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box order-detail-label-overflow"
                  label="현금영수증 종류"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0, borderBottom: 'solid 1px #ced4da' }}
                >
                  {orderDetail.cashReceiptType !== null
                    ? orderDetail.cashReceiptType === 'DEDUCTION'
                      ? '소득 공제용'
                      : '지출 증빙용'
                    : ''}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box order-detail-label-overflow"
                  label="현금영수증 발급 번호"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderBottom: 'solid 1px #ced4da' }}
                >
                  {orderDetail.cashReceiptPhone
                    ? orderDetail.cashReceiptPhone
                    : ''}
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
      <div className="order-detail-modal-subtitle">배송 정보</div>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="택배사"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {orderDetail.deliveryCompany
              ? statusUtil.matchingDeliveryCompany[orderDetail.deliveryCompany]
              : ''}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="송장번호"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {orderDetail.trackingNumber ? (
              <a
                onClick={(e) => deliveryPopup(e, 'delivery', orderDetail)}
                href={`#`}
              >
                {orderDetail.trackingNumber}
              </a>
            ) : (
              ''
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="발송처리일"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0, borderBottom: 'solid 1px #ced4da' }}
          >
            {orderDetail.shipDate
              ? dayjs(orderDetail.shipDate).format('YYYY.MM.DD HH:mm:ss')
              : ''}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className="order-detail-form-border-box"
            label="배송완료일"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderBottom: 'solid 1px #ced4da' }}
          >
            {orderDetail.shipCompleteDate
              ? dayjs(orderDetail.shipCompleteDate).format(
                  'YYYY.MM.DD HH:mm:ss',
                )
              : ''}
          </Form.Item>
        </Col>
      </Row>
      <Row
        className="order-detail-modal-subtitle"
        justify="space-between"
        align="middle"
        wrap={false}
      >
        배송지 정보
        {orderDetail.isManual &&
          (orderDetail.orderDetailStatus === 'ready' ||
            orderDetail.orderDetailStatus === 'paid') && (
            <>
              {editStatus ? (
                <Row align="middle" wrap={false} style={{ gap: '5px' }}>
                  <button
                    className="order-detail-edit-delivery-info-btn cancel"
                    onClick={handleEditCancelClick}
                  >
                    취소
                  </button>
                  <button
                    className="order-detail-edit-delivery-info-btn complete"
                    onClick={handleEditCompleteClick}
                    disabled={disabledEditCompleteBtn()}
                  >
                    수정완료
                  </button>
                </Row>
              ) : (
                <button
                  className="order-detail-edit-delivery-info-btn edit"
                  onClick={handleEditClick}
                >
                  정보수정
                </button>
              )}
            </>
          )}
      </Row>
      <Row align="middle" wrap={false}>
        <Col span={12}>
          <Form.Item
            className={
              'order-detail-form-border-box' + (editStatus ? ' editText' : '')
            }
            label="수취인명"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ borderRight: 0 }}
          >
            {editStatus ? (
              <Input
                name="name"
                value={deliveryInfo.name}
                onChange={handleChange}
              />
            ) : (
              orderDetail.name
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            className={
              'order-detail-form-border-box' + (editStatus ? ' editText' : '')
            }
            label="연락처"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            {editStatus ? (
              <Input
                name="phone"
                value={deliveryInfo.phone}
                onChange={handleChange}
              />
            ) : orderDetail?.phone?.includes('-') ? (
              orderDetail.phone
            ) : orderDetail.phone ? (
              orderDetail.phone?.substr(0, 3) +
              '-' +
              orderDetail.phone?.substr(3, 4) +
              '-' +
              orderDetail.phone?.substr(7, 4)
            ) : (
              '-'
            )}
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        className={
          'order-detail-form-border-box' + (editStatus ? ' editText' : '')
        }
        label="배송지"
        labelAlign="left"
        colon={false}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
      >
        <div className="order-detail-address-info">
          {editStatus ? (
            <>
              <Row align="middle">
                <Input
                  name="postalCode"
                  value={deliveryInfo.postalCode}
                  onClick={() => setIsPostalCodeModalOpen(true)}
                  style={{ width: '100px' }}
                />
                <button
                  className="order-detail-edit-delivery-info-btn edit"
                  onClick={() => setIsPostalCodeModalOpen(true)}
                >
                  우편번호 검색
                </button>
              </Row>
              <Input
                name="address"
                value={deliveryInfo.address}
                onClick={() => setIsPostalCodeModalOpen(true)}
              />
              <Input
                name="addressDetail"
                value={deliveryInfo.addressDetail}
                onChange={handleChange}
              />
            </>
          ) : orderDetail.address ? (
            orderDetail.address +
            (orderDetail.addressDetail ? '\n' + orderDetail.addressDetail : '')
          ) : (
            '-'
          )}
        </div>
      </Form.Item>
      <Form.Item
        className={
          'order-detail-form-border-box' + (editStatus ? ' editText' : '')
        }
        label="배송메모"
        labelAlign="left"
        colon={false}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        style={{ borderBottom: 'solid 1px #ced4da' }}
      >
        <div className="order-detail-address-info">
          {editStatus ? (
            <Input
              name="addressRequest"
              value={deliveryInfo.addressRequest}
              onChange={handleChange}
            />
          ) : orderDetail.addressRequest ===
            '배송 시 요청사항을 선택해주세요.' ? (
            ''
          ) : (
            orderDetail.addressRequest
          )}
        </div>
      </Form.Item>
      {/*반품 관련 내용*/}
      {orderDetail &&
        orderDetail.orderDetailStatus &&
        (orderDetail.orderDetailStatus.includes('return') ||
          orderDetail.returnRefusalDate) && (
          <>
            <div className="order-detail-modal-subtitle">반품 정보</div>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="처리상태"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0, fontWeight: '600', color: 'black' }}
                >
                  {orderDetail.returnRefusalDate
                    ? '반품거부/철회'
                    : statusUtil.orderStatusChange(
                        orderDetail.orderDetailStatus,
                      )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="환불상태"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.paymentStatus &&
                  orderDetail.paymentStatus === 'cancelled'
                    ? orderDetail.cancelAmount?.toLocaleString() +
                      '원 환불처리완료'
                    : ''}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              className="order-detail-form-border-box"
              label="반품사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {orderDetail.returnReason}
            </Form.Item>
            <Form.Item
              className="order-detail-form-border-box"
              label="반품상세사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              <div className="order-detail-address-info">
                {orderDetail.returnReasonDetail}
              </div>
            </Form.Item>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="반품요청일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.returnRequestDate
                    ? dayjs(orderDetail.returnRequestDate).format(
                        'YYYY.MM.DD HH:mm:ss',
                      )
                    : ''}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="반품 요청자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.returnRequestUser &&
                  orderDetail.returnRequestUser === 'ADMIN'
                    ? '판매자'
                    : '구매자'}
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="반품승인일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.returnApprovalDate
                    ? dayjs(orderDetail.returnApprovalDate).format(
                        'YYYY.MM.DD HH:mm:ss',
                      )
                    : ''}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label={
                    orderDetail.orderDetailStatus === 'return_refusal'
                      ? '반품철회일'
                      : '반품완료일'
                  }
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.orderDetailStatus === 'return_refusal'
                    ? orderDetail.returnRefusalDate
                      ? dayjs(orderDetail.returnRefusalDate).format(
                          'YYYY.MM.DD HH:mm:ss',
                        )
                      : ''
                    : orderDetail.returnCompleteDate
                      ? dayjs(orderDetail.returnCompleteDate).format(
                          'YYYY.MM.DD HH:mm:ss',
                        )
                      : ''}
                </Form.Item>
              </Col>
            </Row>
            {orderDetail.returnRefusalDate && (
              <Form.Item
                className="order-detail-form-border-box"
                label="반품철회사유"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
              >
                {orderDetail.returnRefusalReason}
              </Form.Item>
            )}
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="반품 배송비"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.returnResponsibility === 'USER'
                    ? (
                        orderDetail.returnDeliveryPrice -
                        orderDetail.paidTotalDeliveryPrice
                      )?.toLocaleString() + '원'
                    : ''}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="결제정보"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.returnResponsibility === 'USER'
                    ? orderDetail.purchaseReturnPrice
                      ? '선불'
                      : '환불금에서 차감'
                    : '판매자 부담'}
                </Form.Item>
              </Col>
            </Row>
            {orderDetail.etcReturnPrice ? (
              <>
                <Row align="middle" wrap={false}>
                  <Col span={12}>
                    <Form.Item
                      className="order-detail-form-border-box"
                      label="기타 반품비용"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      style={{ borderRight: 0 }}
                    >
                      {orderDetail.etcReturnPrice
                        ? orderDetail.etcReturnPrice.toLocaleString() + '원'
                        : ''}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="order-detail-form-border-box"
                      label="결제정보"
                      labelAlign="left"
                      colon={false}
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                    >
                      환불금에서 차감
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="기타 반품비용 청구사유"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                >
                  <div className="order-detail-address-info">
                    {orderDetail.etcReturnPriceReason}
                  </div>
                </Form.Item>
              </>
            ) : (
              <></>
            )}
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="수거 상태"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {statusUtil.deliveryStatusChange(
                    orderDetail.returnDeliveryStatus,
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="수거방법"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.autoShipping
                    ? '자동 택배사 접수'
                    : orderDetail.returnTrackingNumber
                      ? '택배 수거'
                      : '수거 정보 없음'}
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="수거완료일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.returnCollectionCompleteDate
                    ? dayjs(orderDetail.returnCollectionCompleteDate).format(
                        'YYYY.MM.DD HH:mm:ss',
                      )
                    : ''}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="배송완료일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.returnDeliveryCompleteDate
                    ? dayjs(orderDetail.returnDeliveryCompleteDate).format(
                        'YYYY.MM.DD HH:mm:ss',
                      )
                    : ''}
                </Form.Item>
              </Col>
            </Row>
            <Row align="middle" wrap={false}>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="수거 택배사"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  style={{ borderRight: 0 }}
                >
                  {orderDetail.returnDeliveryCompany
                    ? statusUtil.matchingDeliveryCompany[
                        orderDetail.returnDeliveryCompany
                      ]
                    : ''}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="order-detail-form-border-box"
                  label="수거송장번호"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  {orderDetail.returnTrackingNumber ? (
                    <a
                      onClick={(e) => deliveryPopup(e, 'return', orderDetail)}
                      href={`#`}
                    >
                      {orderDetail.returnTrackingNumber}
                    </a>
                  ) : (
                    ''
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              className="order-detail-form-border-box"
              label="수거지"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              style={{ borderBottom: 'solid 1px #ced4da' }}
            >
              {orderDetail.shipmentPlace}
            </Form.Item>
          </>
        )}
      {isPostalCodeModalOpen && (
        <Modal
          className="order-postal-code-modal"
          open={isPostalCodeModalOpen}
          onCancel={() => setIsPostalCodeModalOpen(false)}
          footer={null}
        >
          <DaumPostcodeEmbed
            style={{
              height: '450px',
            }}
            submitMode={false}
            onComplete={handlePostCode}
          />
        </Modal>
      )}
    </>
  )
}

export default OrderDetailComponent
